// Newsletter popup — porté du thème Ella (Halo), adapté Minimog/Alunara.
// Soumission AJAX (aucun rechargement de page), cookie anti-réaffichage,
// animation d'ouverture image/panneau, support éditeur Shopify.
(function () {
  const COOKIE = 'alunara_np';

  class MNewsletterPopup extends HTMLElement {
    connectedCallback() {
      this.delay = (parseInt(this.dataset.delay, 10) || 60) * 1000;
      this.expire = parseInt(this.dataset.expire, 10) || 15;
      this.form = this.querySelector('form');
      this.submitBtn = this.querySelector('[data-np-submit]');
      this.overlay = this.querySelector('.m-np-overlay') || document.querySelector('.m-np-overlay');

      this.querySelectorAll('[data-np-close]').forEach((el) => {
        el.addEventListener('click', () => this.close(true));
      });
      if (this.overlay) this.overlay.addEventListener('click', () => this.close(true));
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && document.body.classList.contains('m-np-show')) this.close(true);
      });

      if (this.form) {
        this.boundSubmit = this.onSubmit.bind(this);
        this.form.addEventListener('submit', this.boundSubmit);
      }

      const copyBtn = this.querySelector('[data-np-copy]');
      if (copyBtn) {
        copyBtn.addEventListener('click', () => {
          navigator.clipboard.writeText(copyBtn.dataset.code).then(() => {
            copyBtn.textContent = copyBtn.dataset.copiedLabel || copyBtn.textContent;
          });
        });
      }

      if (window.Shopify && window.Shopify.designMode) {
        document.addEventListener('shopify:section:select', (e) => {
          if (e.target.contains(this)) this.open();
        });
        document.addEventListener('shopify:section:deselect', (e) => {
          if (e.target.contains(this)) this.close(false);
        });
      } else if (!this.getCookie(COOKIE)) {
        this.timer = setTimeout(() => this.open(), this.delay);
      }
    }

    open() {
      document.body.classList.add('m-np-show');
      this.imageTimer = setTimeout(() => {
        document.body.classList.add('m-np-image-show');
      }, 700);
    }

    close(remember) {
      if (remember && !(window.Shopify && window.Shopify.designMode)) {
        this.setCookie(COOKIE, 'closed', this.expire);
      }
      document.body.classList.remove('m-np-show');
      clearTimeout(this.imageTimer);
      setTimeout(() => document.body.classList.remove('m-np-image-show'), 500);
    }

    async onSubmit(e) {
      e.preventDefault();
      this.classList.remove('has-error');
      if (this.submitBtn) this.submitBtn.classList.add('is-loading');
      try {
        const res = await fetch(this.form.action, {
          method: 'POST',
          body: new FormData(this.form),
          headers: { Accept: 'text/html' },
        });
        if (res.url && res.url.indexOf('challenge') > -1) {
          // Protection anti-spam Shopify : repli sur la soumission classique (captcha)
          this.form.removeEventListener('submit', this.boundSubmit);
          this.form.submit();
          return;
        }
        if (res.ok) {
          this.setCookie(COOKIE, 'subscribed', 365);
          this.classList.add('is-success');
        } else {
          this.classList.add('has-error');
        }
      } catch (err) {
        this.classList.add('has-error');
      } finally {
        if (this.submitBtn) this.submitBtn.classList.remove('is-loading');
      }
    }

    setCookie(name, value, days) {
      const d = new Date();
      d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
      document.cookie = name + '=' + value + ';expires=' + d.toUTCString() + ';path=/';
    }

    getCookie(name) {
      const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
      return match ? match[2] : '';
    }
  }

  if (!customElements.get('m-newsletter-popup')) {
    customElements.define('m-newsletter-popup', MNewsletterPopup);
  }
})();
